import { gql } from '@apollo/client'

export const SAVE_DRAFT_CASE_EMAIL_MUTATION = gql`
  mutation SaveDraftCaseEmail(
    $id: ID
    $caseId: ID!
    $processingId: ID
    $toAddresses: [String!]
    $ccAddresses: [String!]
    $bccAddresses: [String!]
    $subject: String
    $bodyHtml: String
    $attachmentBlobIds: [String!]
    $removeAttachmentIds: [ID!]
    $visibleForOtherProcessings: Boolean
  ) {
    saveDraftCaseEmail(
      id: $id
      caseId: $caseId
      processingId: $processingId
      toAddresses: $toAddresses
      ccAddresses: $ccAddresses
      bccAddresses: $bccAddresses
      subject: $subject
      bodyHtml: $bodyHtml
      attachmentBlobIds: $attachmentBlobIds
      removeAttachmentIds: $removeAttachmentIds
      visibleForOtherProcessings: $visibleForOtherProcessings
    ) {
      caseEmail {
        id
        toAddresses
        ccAddresses
        bccAddresses
        subject
        bodyHtml
        status
        attachments {
          id
          filename
          url
          signedId
        }
      }
      errors
    }
  }
`
